import { useTranslation } from "react-i18next";
import { SEO } from "@/components/SEO";
import { RevealText } from "@/components/shared/RevealText";
import { SectionReveal } from "@/components/shared/SectionReveal";
import {
  Accordion, AccordionContent, AccordionItem, AccordionTrigger,
} from "@/components/ui/accordion";

export default function Faq() {
  const { t } = useTranslation();
  const items = t("faq.items", { returnObjects: true });

  const schema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: items.map((it) => ({
      "@type": "Question",
      name: it.q,
      acceptedAnswer: { "@type": "Answer", text: it.a },
    })),
  };

  return (
    <div data-testid="faq-page">
      <SEO title={`${t("faq.hero_title")} — Fastority`} description={t("faq.hero_subtitle")} schema={schema} path="faq" />

      <section className="bg-deepblue text-white py-24 sm:py-28 grain-overlay relative overflow-hidden">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 relative">
          <h1 className="font-heading font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tighter">
            <RevealText lines={[t("faq.hero_title")]} />
          </h1>
          <p className="mt-6 text-lg text-white/70">{t("faq.hero_subtitle")}</p>
        </div>
      </section>

      <section className="py-20 sm:py-24 bg-offwhite">
        <SectionReveal className="max-w-2xl mx-auto px-5 sm:px-8">
          <Accordion type="single" collapsible className="space-y-3">
            {items.map((it, i) => (
              <AccordionItem
                key={it.q}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="bg-white rounded-2xl border border-gray-100 shadow-[0_4px_20px_rgba(30,58,138,0.05)] px-6"
              >
                <AccordionTrigger data-testid={`faq-trigger-${i}`} className="font-heading font-semibold text-left text-slate900 hover:no-underline">
                  {it.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-600 leading-relaxed">{it.a}</AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </SectionReveal>
      </section>
    </div>
  );
}
